module.exports = __webpack_public_path__ + "assets/25ab372ccbd340006f4ca7617cfb968f.png";